import React from 'react'
import {Slide, Zoom, Popover} from '@material-ui/core'
import {Alert} from '@material-ui/lab'

function SlideTransition(props) {
  return <Slide {...props} direction="down" />
}
function ZoomTransition(props) {
  return <Zoom {...props} />
}

function PopMessage(props) {
  const e = props
  const {index, handleClose, handleExited} = e
  return (
    <Popover
      style={{zIndex: 99999}}
      anchorOrigin={
        !e.elRef
          ? {vertical: 'top', horizontal: 'center'}
          : {vertical: 'bottom', horizontal: 'center'}
      }
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      anchorEl={e.elRef || window}
      key={index}
      open={e.show}
      onClose={(e, r) => handleClose(e, r, index)}
      onExited={e => handleExited(e, index)}
      TransitionComponent={!e.elRef ? SlideTransition : ZoomTransition}
    >
      <Alert elevation={1} onClose={(e, r) => handleClose(e, r, index)} severity={e.severity}>
        {e.message}
      </Alert>
    </Popover>
  )
}

export default PopMessage
